import { Box, Text, Button } from "@chakra-ui/react";
import { PageCanvas } from "../../layouts/PageCanvas";
import { PageContainer } from "../../layouts/PageContainer";
import { PageHeader } from "../../layouts/PageHeader";
import { Link } from "react-router-dom";

const PageExchange = () => {
  return (
    <PageContainer>
      <PageHeader title="Exchange" isIncludeProfile={true} color="#1C4342"></PageHeader>
      <PageCanvas overflow="auto">
        <Box px={"4"} py={8}>
          <Text fontSize="3xl" color="#1C4342">Search & Data Access Management</Text>  
          <Text fontSize="xl" color="#1C4342">Please select your path:</Text>
          <Box mt={4}>
            <Text fontSize="lg" color="#1C4342">• To submit a data access request, choose <strong>External Search</strong></Text>
            <Text fontSize="lg" color="#1C4342">• To manage data access approvals or denials, choose <strong>Data Access Requests</strong></Text>
          </Box>
          <Box mt={8}>
            <Link to="/external-search">
                <Button colorScheme="teal" size="lg" mr={4} rounded="md">
                    External Search
                </Button>
            </Link>
            
            <Link to="/data-access-requests">
                <Button colorScheme="teal" size="lg" mr={4} rounded="md">
                    Data Access Requests
                </Button>
            </Link> 
          </Box>
        </Box>
      </PageCanvas>
    </PageContainer>
  );
};

export default PageExchange;
